<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <h1 class="text-5xl md:text-6xl font-display font-bold text-gold-400 mb-6">
          Our Services
        </h1>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Premium dental laboratory services with precision, artistry, and cutting-edge technology.
        </p>
      </div>
    </section>

    <!-- Services Categories -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <!-- Cosmetic Restorations -->
          <ServiceCategoryCard
            title="COSMETIC RESTORATIONS"
            description="Transform smiles with natural-looking aesthetic solutions"
            route="/services/cosmetic"
            class="hover:shadow-2xl hover:shadow-gold-900/30"
          />
          
          <!-- Fixed Prosthetics -->
          <ServiceCategoryCard
            title="FIXED PROSTHETICS"
            description="Durable and precise fixed dental restorations"
            route="/services/fixed"
            class="hover:shadow-2xl hover:shadow-gold-900/30"
          />
          
          <!-- Implant Restorations -->
          <ServiceCategoryCard
            title="IMPLANT RESTORATIONS"
            description="Advanced implant-supported solutions"
            route="/services/implant"
            class="hover:shadow-2xl hover:shadow-gold-900/30"
          />
          
          <!-- Surgical Guides -->
          <ServiceCategoryCard
            title="SURGICAL GUIDES"
            description="Digitally planned precise implant positioning"
            route="/services/surgical-guides"
            class="hover:shadow-2xl hover:shadow-gold-900/30"
          />
          
          <!-- Removable Prosthetics -->
          <ServiceCategoryCard
            title="REMOVABLE PROSTHETICS"
            description="Comfortable and functional removable options"
            route="/services/removable"
            class="hover:shadow-2xl hover:shadow-gold-900/30"
          />
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <div class="bg-gradient-dark rounded-3xl p-12 max-w-4xl mx-auto border border-gold-800">
          <h2 class="text-4xl md:text-5xl font-display font-bold text-gold-400 mb-6">
            Need Custom Solutions?
          </h2>
          <p class="text-xl text-gold-300 mb-10 max-w-2xl mx-auto">
            Contact us for personalized dental laboratory services tailored to your specific needs.
          </p>
          <div class="flex flex-col sm:flex-row gap-6 justify-center">
            <a href="tel:+14167279598" class="btn-primary">
              <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Call Us: (416) 727-9598
            </a>
            <a href="mailto:info@canadasmilelab.com" class="btn-secondary">
              <svg class="w-5 h-5 inline-block mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Request a Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ServiceCategoryCard from '@/components/ServiceCategoryCard.vue'

export default {
  name: 'Services',
  components: {
    ServiceCategoryCard
  }
}
</script>